import { ReactNode, useEffect } from "react";

import { Box, useColorMode } from "@chakra-ui/react";

import { useDebugStore } from "~/store/debugStore";

interface BodyProps {
  bodyPadding?: number[];
  bgColor?: string;
  children: ReactNode;
}

export default function Body({ children, bodyPadding, bgColor }: BodyProps) {
  const { colorMode } = useColorMode();
  const tallyRender = useDebugStore((state) => state.tallyRender);

  // Track Body component renders
  useEffect(() => {
    tallyRender("Body");
  }, [tallyRender]);

  return (
    <Box
      p={bodyPadding}
      pb={6}
      height="100%"
      w="100%"
      bgColor={bgColor || (colorMode === "dark" ? "gray.900" : "gray.50")}
    >
      <Box p={0} h={"100%"} minH={"calc(100vh - 166px)"} borderRadius={"lg"}>
        {children}
      </Box>
    </Box>
  );
}
